<template src="./index.html" />
<script>
/* eslint-disable vue/require-prop-types */
export default {
  name: 'EmptyListing',
  props: ['selectedMode', 'searchString'],
  computed: {
    noDataTable() {
      if (this.$store.state.showSpinner) {
        return '';
      } if (this.searchString) {
        return 'No users found with the following searching criteria.';
      }
      let modeTitle;
      switch (this.selectedMode) {
      case 'paid':
        modeTitle = 'paid';
        break;
      default:
        modeTitle = 'any';
      }
      return `You don't have ${modeTitle} users yet`;
    },
  },
};
</script>
<style scoped lang="scss" src="./index.scss"></style>
